import React from 'react';
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import ProspectReceivedMailsTasksTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectReceivedMailsTasksTab/components/ProspectReceivedMailsTasksTabListing/ProspectReceivedMailsTasksTabListing";
import BaseTaskTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseTaskTab/BaseTaskTab";

export default function ProspectReceivedMailsTasksTab() {
    const {currentRoute} = useNavigation();
    const {prospect: prospectId} = currentRoute.params;

    return (
        <BaseTaskTab
            listingComponent={<ProspectReceivedMailsTasksTabListing prospectId={prospectId}/>}
        />
    )
}
